const rechargeModal = {
  'rechargeModal.title': 'Recarga',
  'rechargeModal.inputLabel': 'Valor',
  'rechargeModal.generateRecharge': 'Gerar boleto',
  'rechargeModal.validUntil': 'Vencimento',
  'rechargeModal.instructions':
    'Utilize o número do código de barras para fazer a recarga até a data de vencimento.',
  'rechargeModal.emptyState': 'Não há nenhum valor para recarga.',
  'rechargeModal.copied': 'Copiado!',
  'rechargeModal.copy': 'Copiar código',
  'rechargeModal.sendBySMS': 'Enviar por SMS',
  'rechargeModal.sentBySMS': 'SMS enviado!',
  'rechargeModal.sendByEmail': 'Enviar por email',
  'rechargeModal.sentByEmail': 'Email enviado!',
  'rechargeModal.errorState':
    'Ocorreu um erro ao consultar os dados de recarga.',
  'rechargeModal.confirm': 'Confirmar',
  'rechargeModal.closedValue': 'Valor total',
};

export default rechargeModal;
